import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import cx from 'classnames'
import { HomeIcon } from 'src/theme/icons/icons'
import {
  getCurrentPageUrlInfo,
  updateDocumentTitle,
  isColorWhite,
  handleKeyDown,
} from 'src/utils/helpers'
import { isChatCurrentlyEnabled } from 'src/utils/features'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import Footnote from 'src/components/Footnote'
import './NavBottom.less'

class NavBottom extends Component {
  handleDocumentTitle = title => {
    const { brand, useDefaultDocumentTitle } = this.props
    const documentTitle = useDefaultDocumentTitle || !title ? brand.name : title
    updateDocumentTitle(documentTitle)

    return documentTitle
  }

  handleClickHome = () => {
    const { history, setCurrentlyOpenFeature, openSidebar, areAppActionsDisabled } = this.props
    if (areAppActionsDisabled) {
      return
    }
    setCurrentlyOpenFeature('')

    if (typeof openSidebar === 'function') {
      openSidebar()
    }

    if (history) {
      history.push('/')
      this.handleDocumentTitle()
      return true
    }
  }

  handleClickChat = () => {
    const { history, closeSidebar } = this.props

    if (typeof closeSidebar === 'function') {
      closeSidebar()
    }

    if (history) {
      history.push('/chat')
      this.handleDocumentTitle('Chat')
      return true
    }
  }

  handleClickLogin = () => {
    const {
      history,
      setCurrentlyOpenFeature,
      closeSidebar,
      user,
      areAppActionsDisabled,
    } = this.props
    if (areAppActionsDisabled) {
      return
    }
    setCurrentlyOpenFeature('')
    if (typeof closeSidebar === 'function') {
      closeSidebar()
    }

    if (user) {
      history.push('/user/me')
      this.handleDocumentTitle('Profile')
      return true
    }

    if (history) {
      history.push('/auth/profile')
      this.handleDocumentTitle('Profile')
      return true
    }
  }

  render() {
    const {
      brand,
      location,
      chat,
      chatOptions,
      isAfterHours,
      isChatEmpty,
      className,
      isChatOnlyFeature,
      chatUnreadCount,
      pageBackground,
    } = this.props

    // if (!isNavBottomVisible(location.pathname.includes('chat')) && window.innerWidth < 1000) {
    //   return ''
    // }

    const isChatEnabled = isChatCurrentlyEnabled(chat, chatOptions, isAfterHours, isChatEmpty)

    const currentPageUrl = getCurrentPageUrlInfo(location, 'url')
    let activeTab

    if (currentPageUrl.includes('chat')) {
      activeTab = 'chat'
    } else if (
      currentPageUrl.includes('user') ||
      currentPageUrl.includes('contact') ||
      currentPageUrl.includes('auth')
    ) {
      activeTab = 'profile'
    } else if (currentPageUrl.includes('map')) {
      activeTab = 'services'
    } else if (currentPageUrl.includes('documents/item')) {
      activeTab = 'documentView'
    } else if (currentPageUrl.includes('location')) {
      activeTab = 'location'
    } else {
      activeTab = 'home'
    }

    return (
      <Box
        className={cx({
          'nav-bottom-container': true,
          [className]: !!className,
          'hide-on-mobile':
            activeTab === 'services' || activeTab === 'documentView' || activeTab === 'location',
        })}
        borderColor={
          isColorWhite(pageBackground) ? 'brand.borderColor' : brand.colors.backgroundColor
        }
      >
        <Footnote location='sidebar' className={cx({ 'chat-active': activeTab === 'chat' })} />
        <Box
          className='nav-bottom kiosk--chakra-colors-background'
          borderColor={{
            base: 'brand.borderColor',
            desktop: isColorWhite(pageBackground) ? 'brand.borderColor' : 'transparent',
          }}
        >
          <Flex w='100%'>
            {!isChatOnlyFeature ? (
              <Flex
                cursor={'pointer'}
                pos={'relative'}
                align={'center'}
                flex={1}
                justify={'center'}
                direction={'column'}
                onClick={this.handleClickHome}
                display={{ base: 'flex', desktop: 'none' }}
              >
                {activeTab === 'home' ? (
                  <FontAwesomeIconComponent type='secondary' icon={['fas', 'house']} size='sm' />
                ) : (
                  <HomeIcon color='brand.secondary' boxSize='1.75em' />
                )}

                {activeTab === 'home' ? (
                  <Box
                    mx={2}
                    pos={'absolute'}
                    bottom={'0'}
                    className='kiosk--chakra-colors-background-accent'
                    borderRadius={'5px 5px 0px 0px'}
                    w={'52px'}
                    h={'5px'}
                    minH={'5px'}
                  />
                ) : null}
              </Flex>
            ) : null}
            {isChatEnabled ? (
              <Flex
                cursor={'pointer'}
                pos={'relative'}
                align={'center'}
                flex={1}
                justify={'center'}
                direction={{ base: 'column', sm: 'column', md: 'row' }}
                onClick={this.handleClickChat}
                onKeyDown={handleKeyDown(this.handleClickChat)}
              >
                <FontAwesomeIconComponent
                  type='secondary'
                  icon={activeTab === 'chat' ? ['fas', 'message'] : ['fal', 'message']}
                  size='sm'
                />
                <Stack ml={'14px'} display={{ base: 'none', desktop: 'block' }}>
                  <Text
                    variant='secondary'
                    pos={'relative'}
                    tabIndex='0'
                    display='flex'
                    alignItems='center'
                  >
                    <FormattedMessage id='app.chatTab' defaultMessage='Chat' />
                    {chatUnreadCount > 0 && (
                      <Text as='i' className='unread-count'>
                        {chatUnreadCount}
                      </Text>
                    )}
                  </Text>
                </Stack>
                {activeTab === 'chat' ? (
                  <Box
                    mx={2}
                    w={{ base: '52px', sm: '52px', md: '101px' }}
                    pos={'absolute'}
                    bottom={'0'}
                    className='kiosk--chakra-colors-background-accent'
                    borderRadius={'5px 5px 0px 0px'}
                    h={'5px'}
                    minH={'5px'}
                  />
                ) : null}
              </Flex>
            ) : null}
            <Flex
              cursor={'pointer'}
              pos={'relative'}
              align={'center'}
              flex={1}
              justify={'center'}
              direction={{ base: 'column', sm: 'column', md: 'row' }}
              onClick={this.handleClickLogin}
              onKeyDown={handleKeyDown(this.handleClickLogin)}
            >
              <FontAwesomeIconComponent
                type='secondary'
                icon={activeTab === 'profile' ? ['fas', 'user'] : ['fal', 'user']}
                size='sm'
              />
              <Stack ml={'14px'} display={{ base: 'none', desktop: 'block' }}>
                <Text variant='secondary' tabIndex='0'>
                  <FormattedMessage id='app.profileTab' defaultMessage='Profile' />
                </Text>
              </Stack>
              {activeTab === 'profile' ? (
                <Box
                  mx={2}
                  w={{ base: '52px', sm: '52px', md: '101px' }}
                  pos={'absolute'}
                  bottom={'0'}
                  className='kiosk--chakra-colors-background-accent'
                  borderRadius={'5px 5px 0px 0px'}
                  h={'5px'}
                  minH={'5px'}
                />
              ) : null}
            </Flex>
          </Flex>
        </Box>
      </Box>
    )
  }
}

export default injectIntl(NavBottom)
